var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrizePodium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 63.414,
    viewBox: "0 0 86 63.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122541",
    "data-name": "Group 122541",
    transform: "translate(813 -21952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M23.228,32.084H0V1.2H23.228v30.88ZM10.824,6.83a1.282,1.282,0,0,1,1.03.428,1.656,1.656,0,0,1,.363,1.1A2.355,2.355,0,0,1,11.9,9.455,8.44,8.44,0,0,1,10.84,10.9L7.39,14.6V16h7.28V13.3H13.044l-.087,1.055H10.187l-.014-.037,1.9-2.073a16.916,16.916,0,0,0,1.761-2.138,3.243,3.243,0,0,0,.531-1.787,2.948,2.948,0,0,0-.945-2.285,3.732,3.732,0,0,0-2.593-.857,3.573,3.573,0,0,0-2.655,1,3.234,3.234,0,0,0-.948,2.443l.014.044h2.08A2.154,2.154,0,0,1,9.7,7.331,1.336,1.336,0,0,1,10.824,6.83Z",
    transform: "translate(-809.855 21982)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M23.215,56.1H0V.053H23.215ZM12.677,5.336l-3.955.717V7.277h1.823V14.5l-1.8.22V16h5.736V14.719l-1.8-.22Z",
    transform: "translate(-781.267 21958)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M24.032,25.915H6.981L6.967,25.9l-1.244-.008c-1.853-.012-3.77-.025-5.723-.025V.82H23.984c0,.468,0,.941.005,1.4V2.23q0,.431,0,.862h.038V25.914ZM7.962,13.1l-.014.044a2.523,2.523,0,0,0,1.029,2.223,4.194,4.194,0,0,0,2.552.787,4.3,4.3,0,0,0,2.728-.839,2.782,2.782,0,0,0,1.066-2.3,2.557,2.557,0,0,0-.465-1.516,2.731,2.731,0,0,0-1.352-.967,2.934,2.934,0,0,0,1.209-.978,2.272,2.272,0,0,0,.439-1.322,2.736,2.736,0,0,0-.985-2.255,4.115,4.115,0,0,0-2.641-.791,3.845,3.845,0,0,0-2.49.813A2.435,2.435,0,0,0,8.079,8.06l.014.044h2.073a1.161,1.161,0,0,1,.41-.923,1.5,1.5,0,0,1,1.011-.352,1.4,1.4,0,0,1,1.062.388,1.453,1.453,0,0,1,.366,1.033,1.589,1.589,0,0,1-.366,1.11,1.466,1.466,0,0,1-1.128.4h-1.2v1.6h1.2a1.769,1.769,0,0,1,1.241.392,1.619,1.619,0,0,1,.421,1.234,1.474,1.474,0,0,1-.428,1.113,1.625,1.625,0,0,1-1.168.41,1.6,1.6,0,0,1-1.113-.4,1.315,1.315,0,0,1-.439-1.014H7.962Z",
    transform: "translate(-752.53 21989)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69486",
    "data-name": "Rectangle 69486",
    width: 28,
    height: 3,
    transform: "translate(-813 21978)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69487",
    "data-name": "Rectangle 69487",
    width: 28,
    height: 4,
    transform: "translate(-784 21952)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69488",
    "data-name": "Rectangle 69488",
    width: 28,
    height: 4,
    transform: "translate(-755 21983)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizePodium);
export default __webpack_public_path__ + "static/media/prizePodium.90d1890082439032e6a6439bbd736671.svg";
export { ForwardRef as ReactComponent };